export default "__VITE_ASSET__DekDYH4v__"